import CarotekColors from "@carotek/utils/Colors";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    heading = "heading",
    subText = "subText",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.subText]: string;
    };
    extendedStyles?: BannerStyles;
}

export interface BannerStyles {
    overlayWrapperStyles?: InjectableCss;
    titleStyles?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    subTextStyle?: TypographyPresentationProps;
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

const pageTitleStyles: BannerStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            text-align: center;
            align-items: center;
            margin-bottom: 30px;
        `,
    },
    titleStyles: {
        css: css`
            margin-bottom: 2px;
        `,
    },
    subTextStyle: {
        color: `${CarotekColors.red1}`,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = pageTitleStyles;

const BasicPageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography variant="h2" as="h1" data-test-selector="BasicPageTitle" {...styles.titleStyles}>
                {fields.heading || fields.overrideTitle || pageTitle}
            </Typography>
            <Typography {...styles.subTextStyle}> {parse(fields.subText, parserOptions)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BasicPageTitle),
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Custom Page Title",
                defaultValue: "",
                sortOrder: 0,
            },
            {
                name: fields.subText,
                displayName: "Sub Text",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
